import {Injectable} from '@angular/core';
import {NativeGeocoder, NativeGeocoderReverseResult, NativeGeocoderOptions} from '@ionic-native/native-geocoder';
import {Plugins} from "@capacitor/core";
import {Events, Platform} from "ionic-angular";

const {Geolocation} = Plugins;

export interface latLng {
    lat: number;
    lng: number;
}

/*
  Generated class for the LocationServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocationServiceProvider {

    constructor(private platform: Platform, private nativeGeocoder: NativeGeocoder, public events: Events) {
    }

    geolocate() {
        return new Promise((resolve, reject) => {
            Geolocation.getCurrentPosition().then((position) => {
                let latLng = <latLng>{
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                resolve(latLng);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    getCurrentLocation(latitude, longitude) {
        let $this = this;

        return new Promise((resolve, reject) => {
            let options: NativeGeocoderOptions = {
                useLocale: true,
                maxResults: 1
            };

            $this.nativeGeocoder
                .reverseGeocode(latitude, longitude, options)
                .then((result: NativeGeocoderReverseResult[]) => {
                    resolve(result[0]);
                }).catch((error: any) => {
                reject(error);
            });
        })
    }

    getCurrentLocationName(latitude, longitude) {
        this.getCurrentLocation(latitude, longitude).then((location: any) => {
            let currentLocation = '';

            if (location.locality && location.countryName) {
                currentLocation = `${location.locality}, ${location.countryName}`;
            }

            this.events.publish('geolocation:location', currentLocation);
        }).catch((error) => {
            if (!this.platform.is('cordova')) {
                this.events.publish('geolocation:location', 'Tap here to search on map');
            } else {
                this.events.publish('geolocation:location', 'Tap here to search on map');
            }
        })

    }

}



// WEBPACK FOOTER //
// ./src/providers/location-service/location-service.ts